import { render, staticRenderFns } from "./ArrowDownIcon.vue?vue&type=template&id=cad6481e"
import script from "./ArrowDownIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowDownIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports